module.exports = __webpack_public_path__ + "static/img/shouyebeijing.bb1720e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shouyebeijing.png
// module id = /8ht
// module chunks = 95